import React, { useState, useEffect, useTransition } from "react";
import axios from "axios";
import moment from "moment";
import { Loader } from "../common/loader";


export const BookingMailAdmin = () => {
  const [inquiries, setInquiries] = useState([]);
  const [sortedField, setSortedField] = useState(null);
  const [sortOrder, setSortOrder] = useState("desc");
  const [selectedId, setSelectedId] = useState(null);
  const [error, setError] = useState("");
  const [selectedInquiry, setSelectedInquiry] = useState(null);
  const [isPending, startTransition] = useTransition();
  const [allInquiries, setAllInquiries] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Items per page

  const currentDate = moment().format("YYYY-MM-DD");

  useEffect(() => {
    fetchAllInquiries();
  }, []);

  const prioritizeCurrentDateInquiries = (inquiries) => {
    console.log(inquiries);
    const today = moment().format("YYYY-MM-DD");
    const todayInquiries = inquiries.filter(
      (inquiry) => moment(inquiry.inquiryDate).format("YYYY-MM-DD") === today
    );
    const otherInquiries = inquiries.filter(
      (inquiry) => moment(inquiry.inquiryDate).format("YYYY-MM-DD") !== today
    );
    // Sort today's inquiries by time (descending)
    todayInquiries.sort(
      (a, b) => moment(b.inquiryDate) - moment(a.inquiryDate)
    );

    // Sort other inquiries by date (descending)
    otherInquiries.sort(
      (a, b) => moment(b.inquiryDate) - moment(a.inquiryDate)
    );

    // Combine today's inquiries first, then others
    return [...todayInquiries, ...otherInquiries];
  };

  const fetchAllInquiries = async () => {
    setError("");
    startTransition(async () => {
      try {
        const response = await axios.get(
          `https://api.bgmhotel.com/roomBookInquiry`
        );
        const allData = response.data.data;
        const prioritizedData = prioritizeCurrentDateInquiries(allData);
        setAllInquiries(prioritizedData);
        setInquiries(prioritizedData);
      } catch (err) {
        setError(err.response?.data?.message || "Failed to fetch inquiries.");
      }
    });
  };

  // const fetchAllInquiries = async () => {
  //   setError("");
  //   startTransition(async () => {
  //     try {
  //       const response = await axios.get(
  //         `https://api.bgmhotel.com/roomBookInquiry`
  //       );
  //       setAllInquiries(response.data.data);
  //       setInquiries(response.data.data);
  //     } catch (err) {
  //       setError(err.response?.data?.message || "Failed to fetch inquiries.");
  //     }
  //   });
  // };

  useEffect(() => {
    fetchAllInquiries();
  }, []);

  const handleCheckboxChange = async (id) => {
    setSelectedId(id);
    const selectedInquiry = inquiries.find((inquiry) => inquiry._id === id);

    startTransition(async () => {
      try {
        const response = await axios.get(
          `https://api.bgmhotel.com/roomBookInquiry/${id}`
        );
        const inquiry = response.data.data;

        setSelectedInquiry(inquiry);

        const emailDetails = {
          email: inquiry.email,
          subject: `Booking Confirmation for ${inquiry._id}`,
          text: inquiry,
        };

        await axios.post(
          "https://api.bgmhotel.com/send-confirmation-email",
          emailDetails
        );
        alert("Email sent successfully!");
      } catch (err) {
        setError("Failed to send email.");
      }
    });
  };

  const handleSort = (field) => {
    if (sortedField === field) {
      setSortOrder(sortOrder === "desc" ? "asc" : "desc");
    } else {
      setSortedField(field);
      setSortOrder("desc");
    }
  };

  const sortedInquiries = [...inquiries].sort((a, b) => {
    if (!sortedField) return 0;

    if (sortOrder === "desc") {
      return a[sortedField] > b[sortedField] ? 1 : -1;
    } else {
      return a[sortedField] < b[sortedField] ? 1 : -1;
    }
  });

  const fiterData = (event) => {
    event.preventDefault();
    const checkInDate = event.target.checkInDate.value;
    if (!checkInDate) {
      setInquiries(allInquiries);
      return;
    }

    const filtered = allInquiries.filter(
      (inquiry) => inquiry.checkIn >= checkInDate
    );
    setInquiries(filtered);
  };

  // Pagination logic
  const totalPages = Math.ceil(inquiries.length / itemsPerPage);
  const displayedInquiries = sortedInquiries.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <div className="accordion-item inquiryStyle">
        <h2 className="accordion-header">
          <button
            className="accordion-button accordion-email collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseThree"
            aria-expanded="false"
            aria-controls="collapseThree"
          >
            Booking received
          </button>
        </h2>
        <div
          id="collapseThree"
          className="accordion-collapse collapse"
          data-bs-parent="#adminPanelRoomDetail"
        >
          <div className="accordion-body">
            <h6>Filter Data By :</h6>
            <form onSubmit={fiterData}>
              <div className="col-12 card p-3">
                <div className="row">
                  <div className="col-md-6 col-sm-12">
                    <label htmlFor="checkInDate">Check In Date</label>
                    <input
                      type="date"
                      name="checkInDate"
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-3 col-sm-12 pt-4">
                    <button
                      type="submit"
                      className="btn btn-primary-custom animated slideInLeft col-sm-12"
                    >
                      Filter Data
                    </button>
                  </div>
                  <div className="col-md-3 col-sm-12">
                    <button
                      type="button"
                      className="btn
                  btn-dark-custom
                  animated
                  slideInRight mt-4 col-sm-12"
                      onClick={() => setInquiries(allInquiries)}
                    >
                      Reset Filter
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <div className="col-12 mt-5 amenities">
              <div className="card">
                <h6 className="card-header">
                  Received Booking Customer details to Follow Back
                </h6>

                {/* {displayedInquiries && (
                  <>
                  </>
                ):()} */}
                <div className="card-body">
                  {isPending && "Email Sending Please Wait..."}
                  {error && <p className="text-danger">{error}</p>}
                  {!isPending && displayedInquiries.length > 0 && (
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead
                          className="table-dark"
                          style={{ textWrap: "nowrap" }}
                        >
                          <tr>
                            <th>Select</th>
                            <th>Sr. No.</th>
                            <th onClick={() => handleSort("inquiryDate")}>
                              Inquiry Received Date
                              {sortedField === "inquiryDate" &&
                                (sortOrder === "asc" ? " ↑" : " ↓")}
                            </th>
                            <th onClick={() => handleSort("checkIn")}>
                              Room Check In
                              {sortedField === "checkIn" &&
                                (sortOrder === "asc" ? " ↑" : " ↓")}
                            </th>
                            <th>Room Check Out</th>
                            <th>Customer Name</th>
                            <th>Customer Email</th>
                            <th>Main Contact</th>
                            <th>Alternate Contact</th>
                            <th>Room Type</th>
                            <th>Price / Night</th>
                            <th>Customer State</th>
                            <th>Customer City</th>
                          </tr>
                        </thead>
                        <tbody>
                          {displayedInquiries &&
                          displayedInquiries.length !== 0 ? (
                            displayedInquiries.map((inquiry, index) => (
                              <tr key={inquiry._id}>
                                <td>
                                  {isPending && <Loader className="loader" />}
                                  <button
                                    style={{ textWrap: "nowrap" }}
                                    className={
                                      selectedId === inquiry._id
                                        ? "btn btn-primary animated slideInLeft col-12 "
                                        : "btn btn-primary-custom animated slideInLeft col-12"
                                    }
                                    disabled={inquiry.checkIn < currentDate}
                                    onClick={() =>
                                      handleCheckboxChange(inquiry._id)
                                    }
                                  >
                                    {selectedId === inquiry._id
                                      ? "Mail Sent"
                                      : "Send Mail"}
                                  </button>
                                </td>
                                <td>
                                  {(currentPage - 1) * itemsPerPage + index + 1}
                                </td>
                                <td>{inquiry.inquiryDate}</td>
                                <td>{inquiry.checkIn}</td>
                                <td>{inquiry.checkOut}</td>
                                <td>{inquiry.consumerName}</td>
                                <td>{inquiry.email}</td>
                                <td>{inquiry.phoneNumber}</td>
                                <td>{inquiry.alterNumber}</td>
                                <td>{inquiry.roomType}</td>
                                <td>{inquiry.price}</td>
                                <td>{inquiry.state}</td>
                                <td>{inquiry.city}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="13" className="text-center">
                                No records found
                              </td>
                            </tr>
                          )}
                        </tbody>

                        {/* <tbody>
                          {displayedInquiries &&
                          displayedInquiries.length > 0 ? (
                            displayedInquiries.map((inquiry, index) => (
                              <tr key={inquiry._id}>
                                <td>
                                  {isPending && <Loader className="loader" />}
                                  <button
                                    className={
                                      selectedId === inquiry._id
                                        ? "btn customButton-active col-12"
                                        : "btn btn-outline-secondary col-12"
                                    }
                                    disabled={inquiry.checkIn < currentDate}
                                    onClick={() =>
                                      handleCheckboxChange(inquiry._id)
                                    }
                                  >
                                    {selectedId === inquiry._id
                                      ? "Mail Sent"
                                      : "Send Mail"}
                                  </button>
                                </td>
                                <td>
                                  {(currentPage - 1) * itemsPerPage + index + 1}
                                </td>
                                <td>{inquiry.inquiryDate}</td>
                                <td>{inquiry.checkIn}</td>
                                <td>{inquiry.checkOut}</td>
                                <td>{inquiry.consumerName}</td>
                                <td>{inquiry.email}</td>
                                <td>{inquiry.phoneNumber}</td>
                                <td>{inquiry.alterNumber}</td>
                                <td>{inquiry.roomType}</td>
                                <td>{inquiry.price}</td>
                                <td>{inquiry.state}</td>
                                <td>{inquiry.city}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="13" className="text-center">
                                No records found
                              </td>
                            </tr>
                          )}
                        </tbody> */}
                      </table>
                    </div>
                  )}
                </div>
                <div className="card-footer">
                  <div className="pagination text-center">
                    {[...Array(totalPages).keys()].map((page) => (
                      <button
                        key={page}
                        className={`btn ${
                          currentPage === page + 1
                            ? "btn-primary"
                            : "btn-outline-secondary"
                        } mx-1`}
                        onClick={() => handlePageChange(page + 1)}
                      >
                        {page + 1}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
